<flex-tree-input #flexTreeInput [nodes]="nodes" [multiple]="multiple" [showFilter]="true"
  [formControl]="selectedControl" [showCheckAll]="showCheckAll">
</flex-tree-input>
